import DnWidget from './DnWidget.vue'

export default DnWidget
